module.exports = __webpack_public_path__ + "actor1.png?8ae4a2f8a6f84afeb10e873bfcebe1cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/actor1.png
// module id = 57
// module chunks = 0